<template>
    <div>
        <modal
            :name="'hide-learning-path-modal' + learningPath.id"
            height="auto"
            :width="400"
            :adaptive="true"
            ref="hide-learning-path-modal"
            @opened="onOpened"
            tabindex="0"
            :scrollable="true"
        >
            <div class="modal">
                <span class="modal__title" v-html="$t('UncompletedCourses.modal_hide_course')"></span>
                <ul class="modal__action-buttons">
                    <li tabindex="0" @keyup.enter="$modal.hide('hide-learning-path-modal' + learningPath.id)">
                        <TotemButton
                            color="basic"
                            :fullWidth="false"
                            @click="$modal.hide('hide-learning-path-modal' + learningPath.id)"
                            class="-margin-left"
                            :label="$t('General.no')"
                        />
                    </li>
                    <li tabindex="0" @keyup.enter="onhideLearningPathAccepted()">
                        <TotemButton
                            color="primary"
                            :fullWidth="false"
                            @click="onhideLearningPathAccepted()"
                            class="-margin-left"
                            :label="$t('General.yes')"
                        />
                    </li>
                </ul>
            </div>
        </modal>
        <TotemToast ref="toast" :minWidth="230" />
    </div>
</template>
<script>
export default {
    name: 'hide-learning-path-modal',
    props: {
        learningPath: {
            type: Object
        }
    },
    methods: {
        onOpened () {
            this.$refs['hide-learning-path-modal'].$el.focus()
        },
        async onhideLearningPathAccepted () {
            await this.$store.dispatch('LearningPaths/hideOrRestoreUncompletedLearningPathFromList', {
                learningPathId: this.learningPath.id,
                isHidden: true
            })
            await this.$store.dispatch('LearningPaths/loadSubscribedLearningPaths')
            this.$modal.hide('hide-learning-path-modal' + this.learningPath.id)
            this.$refs.toast.show(this.$t('UncompletedCourses.learning_path_hidden'))
        }
    }
}
</script>

<style lang="scss" scoped>
.modal {
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &__title {
        margin: 0 0 25px;
        font-family: QuickSand-Medium, sans-serif;
        font-size: 2rem;
        color: $black;
    }

    &__action-buttons {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
}
</style>
